import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=27fe1e9c&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=27fe1e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe1e9c",
  null
  
)

export default component.exports